import MapToolsHome from '@/components/map-tools'


export default {
  path: '/map-tools',
  component: MapToolsHome
}



// WEBPACK FOOTER //
// ./src/router/map-tools.js